import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { ICoordinates } from '../../../types/residentials';
import { MapPin } from '../../../components/MapPin';

interface IGetGeoObjectOptions {
  markAsPlus: boolean;
  name: string;
  coordinates?: ICoordinates | null;
  id?: string | null;
}

export const getGeoObject = ({ name, coordinates, id, markAsPlus }: IGetGeoObjectOptions): IMapGeoObject | null => {
  const lat = coordinates?.lat;
  const lng = coordinates?.lng;

  if (!lat || !lng || !id) {
    return null;
  }

  return {
    type: 'Point',
    name,
    options: {
      coordinates: { lat, lng },
      html: ReactDOMServer.renderToStaticMarkup(<MapPin theme={markAsPlus ? 'plus' : 'default'} />),
      id,
      width: 32,
      height: 32,
      zIndex: markAsPlus ? 100 : undefined,
    },
  };
};
